import { css } from '@emotion/core'

export default () => css`
.large-image-content-section {
    padding: 70px 0 50px;
    background: #F9F9F9; }
    .large-image-content-section .large-image-content-row {
      width: 100%;
      display: -webkit-box;
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-wrap: wrap;
      -moz-flex-wrap: wrap;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -ms-justify-content: space-between;
      justify-content: space-between;
      -ms-flex-pack: space-between; }
    .large-image-content-section .large-image-content-block {
      width: 48%; }
    .large-image-content-section .large-image-content-image-holder {
      height: 600px;
      position:relative; }
      .large-image-content-section .large-image-content-image-holder .global-image {
        width: 100%;
        height: 100%;
        object-fit: cover; }
      .large-image-content-section .large-image-content-image-holder .content-tag {
        position: absolute;
        top: 8px;
        left: 8px;
        z-index: 1; }
    .large-image-content-section .large-image-content-text-block {
      margin-top: 35px;
      color: #191919; }
    .large-image-content-section .large-image-content-block-title {
      font-family: "Switzer-Semibold", sans-serif;
      font-size: 35px;
      line-height: 40px; }
    .large-image-content-section .large-image-content-block-description {
      margin-top: 15px;
      font-size: 16px;
      line-height: 24px; }
    .large-image-content-section .large-image-content-block-link-row {
      margin-top: 24px; }
    .large-image-content-section .large-image-content-block-link {
      color: #191919;
      font-size: 14px;
      text-decoration: underline;
      letter-spacing: 1.5px;
      text-transform: uppercase; }
      .large-image-content-section .large-image-content-block-link:hover {
        text-decoration: none; }
    @media (max-width: 767px) {
      .large-image-content-section {
        padding: 32px 0 0; }
        .large-image-content-section .large-image-content-block {
          width: 100%;
          margin-bottom: 40px; }
        .large-image-content-section .large-image-content-image-holder {
          height: 350px; }
        .large-image-content-section .large-image-content-text-block {
          margin-top: 30px; }
        .large-image-content-section .large-image-content-block-title {
          font-size: 22px;
          line-height: 29px; }
        .large-image-content-section .large-image-content-block-description {
          margin-top: 8px;
          font-size: 12px;
          line-height: 18px;
          letter-spacing: 0.5px; }
        .large-image-content-section .large-image-content-block-link-row {
          margin-top: 20px; }
        .large-image-content-section .large-image-content-block-link {
          font-size: 12px; } }
`